// src/pages/GroomerRow.js
import React from "react";
import { TableRow, TableCell, IconButton } from "@mui/material";
import { ArrowForwardIos as ArrowForwardIcon } from "@mui/icons-material";
import { Link } from "react-router-dom";
import CommentsMenu from "../components/CommentsMenu";
import ImageGalleryDropdown from '../components/ImageGalleryDropdown';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';

function GroomerRow({ groomer, groomers }) {
  const images = groomer.bucket?.images || [];
  return (
    <TableRow>
      {/* Redirect Icon */}
      <TableCell>
        <IconButton
          component={Link}
          to={`/groomers/${groomer.id}`}
          state={{ records: groomers }}
          aria-label="view-details"
        >
          <ArrowForwardIcon sx={{ fontSize: 'small' }} />
        </IconButton>
      </TableCell>
      <TableCell>{groomer.firstName}</TableCell>
      <TableCell>{groomer.lastName}</TableCell>
      <TableCell>{groomer.address}</TableCell>
      <TableCell>{groomer.phone1}</TableCell>
      <TableCell>{groomer.phone2}</TableCell>
      <TableCell>{groomer.email}</TableCell>
      <TableCell>{groomer.active ? "Active" : "Inactive"}</TableCell>
      <TableCell>
        <CommentsMenu comments={groomer.comments} />
      </TableCell>
      <TableCell>
        {images.length > 1 ? (
          <ImageGalleryDropdown
            images={images}
            onUploadSuccess={null}
            onDelete={null}
            groomerId={groomer.id}
            readOnly={true}
          />
        ) : images.length === 1 ? (
          <a href={images[0].imageUrl} target="_blank" rel="noopener noreferrer">
            <IconButton aria-label="view image">
              <PhotoLibraryIcon sx={{ fontSize: '18px', color: 'primary.main' }} />
            </IconButton>
          </a>
        ) : null}
      </TableCell>
    </TableRow>
  );
}

export default GroomerRow;